import { CanActivateFn } from '@angular/router';

import { LoginGuard } from '@efficiently/client-core-guards';

/**
 * The default sign-in page answers a signed-in visitor the way `/login` does, with one exception: an
 * emailed sign-in link carries its token in the fragment, and the visitor clicked it to sign in as
 * that address. Bouncing it to the projects would drop the link without a word.
 */
export const otpLoginGuard: CanActivateFn = (route, state) => Boolean(route.fragment) || LoginGuard(route, state);
